/* eslint-disable global-require */
const axios = require('axios')

const accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijk1ZTI3OGM1NGViZWE4YWQwOGIwYjcxYmNjYmNlNTA1OGYwYmMwOTRjNWU3OWUzYzViMDM3YTEzYmE0MWIwZGJlMzc1ZTQ2NTg4MTEyMmU3In0.eyJhdWQiOiIyIiwianRpIjoiOTVlMjc4YzU0ZWJlYThhZDA4YjBiNzFiY2NiY2U1MDU4ZjBiYzA5NGM1ZTc5ZTNjNWIwMzdhMTNiYTQxYjBkYmUzNzVlNDY1ODgxMTIyZTciLCJpYXQiOjE2Nzg4OTI4NTEsIm5iZiI6MTY3ODg5Mjg1MSwiZXhwIjoxNzEwNTE1MjUxLCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.kalaWkPWD30xcV8hfCzj_w_e7EwXUa_1UpE4PJW9zs_Sp2Uoa351bjgQQ7V9vRPOG0g3-OsEcI1SP3D8_mvWykfp1oXavzYYDwrayXEsYjK-bhl7TASSpXeECr8lM4nB_xyC_l6SPiAscHyw3r0sX-_LHDZVUU8ViKmtESVyN6wMahVnx_nG3s_g1zHalE-KjoH4ObQswLlIgp8j_cBIKFmAndy25QB6bbF7nx_0OU1n3k5k0LuaPitxPoBeAn2EAePtnx3pGbPn1iewg9bL5KJgZhfsLOo2DaK1I5CchzJzZm2uz6VhAD8vDlWSP67KL1x0DuDrN27NGYtjUQ7tqipvp3RGCfTqbGH-T8QTEo15Ymy9CTexkQ48XJwEgAHmY1iPw33Zc9Pur3sencJbflxdCKhuHc7uvnEXzGj8gmAioZofRStXn4xaF6OTzijvw9LwtASnMibc1igdRSBqPpNGs6h7zuOMzHNSmSPrJCGOvUelplIuR9Io1CFpDsCCPiNtpprE3paDcnLxAwQrn8HOOp08Na_c5PQTGA8pPnTsn8Xh23lonf9emRGy23eqVIov2F3ri1LmNV3MsX__KGTNHYTdypTFQUoV_yLTDbQA-DCzuW6fkABA1U58hpK8uDxZrWVnTdMbsM9MDwIIJqR8ZbG6u8HcNkDENXCWkG8'

module.exports.reportTransactions = async (userId, storeId, dateMin, dateMax, searchType) => {
  const getReport = await axios.get('https://app.manyconvert.com/api/newService/teste', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    params: {
      user_id: userId,
      store_id: storeId,
      date_min: dateMin,
      date_max: dateMax,
      searchType,
    },
  }).then(resp => resp.data)
  return getReport
}
